import React, { createContext, useContext, useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { setLoadingHandler } from "../utils/loadingManager";

type LoadingContextProps = {
  loading: boolean;
};

const LoadingContext = createContext<LoadingContextProps>({ loading: false });

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoadingHandler(setLoading);
    return () => setLoadingHandler(null);
  }, []);

  return (
    <LoadingContext.Provider value={{ loading }}>
      {children}
      {loading && (
        <div style={styles.overlay}>
          <CircularProgress size={50} style={{ color: "#fff" }} />
        </div>
      )}
    </LoadingContext.Provider>
  );
};

const styles = {
  overlay: {
    position: "fixed" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
  },
};
